import api from "../../../../Shared/interceptor/api"
import { CITY_CONFIG } from "../../constant/constant"

export function geoCode(address) {
    return api.request(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_GOOGLE_KEY}`)
}

const headers = {
    "content-type": "application/json",
    "unmaskrequest": "enable",
    "product": "ORP",
    "x-app-version": "1.0.0",
    "x-api-key": process.env.REACT_APP_MODE === "UAT" && process.env.REACT_APP_BFE_API_KEY,
    "x-service-id": process.env.REACT_APP_BFE_SERVICE_ID,
    "Opco": process.env.REACT_APP_OPCO,
    "run-mode": 'beta',
}
export function getCityData() {
    return api.request({ url: `/orp/bfe/api/portal-service/resource/v1/config?code=${CITY_CONFIG}`, headers })
}

export function getFormSchema(url) {
    return api.request(url)
}

export function getContactFormSchema(url) {
    return api.request(url)
}
